class MathExt
  @round_to: (number, digits) ->
    multiple = Math.pow(10, digits)
    return Math.round(number * multiple) / multiple

module.exports = MathExt
